<template>
  <div class="body">
    <div class="title" style="border-bottom: 1px solid #ccc;"><a>プライバシーの保護</a> 
     	</div>

     	
     	<p style="font-size: 18px;font-weight: 600;color: #4c4c4c; margin-top: 20px;"> 第1 目的</p>
     	<p style="padding-top: 16px;">このプライバシーポリシーは、弊社がお客様の個人情報を取得する際の取得する個人情報及び利用目的を明確にするとともに、個人情報管理の弊社の方針を明らかにするものです。</p>
     	
     	<p style="font-size: 18px;font-weight: 600;color: #4c4c4c; margin-top: 20px;">第2 個人情報保護の範囲</p>
     	<p style="padding-top:16px;">本ガイドラインの対象となる個人情報は、「生存する個人に関する情報」であって、当該情報に含まれる氏名、生年月日その他の記述というにより特定の個人を識別する事ができるものをいいます。<br>具体例<br>お名前、郵便番号、住所、氏名、電話番号、生年月日など ID、パスワード、メールアドレス、クレジットカード情報</p>
     	
     	<p style="font-size: 18px;font-weight: 600;color: #4c4c4c; margin-top: 20px;">第3 個人情報の利用目的</p>
     	<p style="padding:16px 0px;">弊社は、取得した個人情報を、次の目的の為に利用させていただきます。<br>• 弊社のサービスおよびシステムの運営<br>• 公告、メンテナンス、重要なお知らせなどのご案内<br>• お客様にとって有用と思われる情報・サービスをご紹介するためのご通知<br>• 弊社のサービスをご利用・ご購入いただいた際の発送に関わる業務<br>• 弊社ならびに弊社提携先の商品・サービスのためのマーケティング活動</p>
     	
     	<p style="font-size: 18px;font-weight: 600;color: #4c4c4c; margin-top: 20px;">第4 個人情報の取得</p>
     	<p style="padding:16px 0px;">1. ご本人から直接個人情報を取得する際には、ご本人に対して利用目的を明らかにしてご通知します。<br>2. 前項により取得した個人情報を、通知の範囲を超えた目的に利用する際にはあらかじめご本人に対して利用すること及び利用目的をご通知いたします。</p>
     	

        <p style="font-size: 18px;font-weight: 600;color: #4c4c4c; margin-top: 20px;">第5 個人情報の管理・利用</p>
     	<p style="padding:16px 0px;">1. 弊社が取得した個人情報は、このプライバシーポリシー及び弊社の規定に従って適切に管理し、個人情報の漏えい、滅失またはき損の 防止その他の個人情報の安全管理のために必要かつ適切な措置を整えます。<br>2. 弊社は、第3記載の利用目的を超えて、取得した個人情報を利用しません。<br>3. 弊社は、お客様の個人情報を、正確、最新のものとするよう適切な処置を講じます。</p> 
          
        <p style="font-size: 18px;font-weight: 600;color: #4c4c4c; margin-top: 20px;">第6 個人情報の利用停止</p>
     	<p style="padding:16px 0px;">弊社は、ご本人から個人情報の利用停止の申し込みがあった場合は、直ちに個人情報の利用を停止します。ただし、本ガイドライン第3の1による代金のご請求等弊社サービスに不可欠な場合を除きます。</p>    
           
        <p style="font-size: 18px;font-weight: 600;color: #4c4c4c; margin-top: 20px;">第7 個人情報の開示</p>
     	<p style="padding:16px 0px;">弊社では、下記の場合を除き個人情報を開示することはありません。<br>1. 第8，9に定める場合<br>2. 集計および分析等により得られたものを、個人を識別または特定できない状態で提携先等第三者に開示または提供する場合<br>3. ご本人の同意を得た上で個人情報を開示または利用する場合<br>4. 裁判所の発する令状その他裁判所の決定、命令または法令に基づき開示する場合<br>5. 検察・警察・監督官庁、弁護士会からの適法・適式な手順により情報の照会があった場合<br>6. プロバイダー責任法（正称：特定電気通信役務提供者の損害賠償責任の制限及び発信者情報の開示に関する法律）第4条に該当する請求があった場合<br>7. ご本人からの開示の請求があった場合</p>    
           
        <p style="font-size: 18px;font-weight: 600;color: #4c4c4c; margin-top: 20px;">第8 個人情報の第三者への提供</p>
     	<p style="padding:16px 0px;">1. 弊社は、ご通知、商品配送、その他第4の目的に必要な最小限の個人情報については、第三者に提供いたします。<br>2. 前項に定める他、弊社は本人の事前承認無しに個人情報を第三者に開示・提供しません。</p>       
         
        <p style="font-size: 18px;font-weight: 600;color: #4c4c4c; margin-top: 20px;">第9 本人情報開示</p>
     	<p style="padding:16px 0px;">弊社は、ご本人より個人情報の開示、訂正、利用停止、削除のご依頼があった場合、ご本人様であることを確認させていただいた上で、本人情報の開示をさせていただきます。
</p>        
      
        <p style="font-size: 18px;font-weight: 600;color: #4c4c4c; margin-top: 20px;">第10 免責</p>
     	<p style="padding:16px 0px;">弊社では、お客様の不注意により個人情報が漏えい・改ざんされた場合は、一切責任を負いません。</p>  
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  },
  components: {
    
  },
  methods: {
  },
  mounted(){
    
    
  }
}
</script>
<style scoped>
  .body{
    margin: 0 auto;
    width: 1200px;
    margin-top: 32px;
    margin-bottom: 80px;
    font-family: 微软雅黑;
    color: #666;
    font-size: 14px;
  }
  .body p{
    font-size: 16px;
    font-family: "ＭＳ Ｐ明朝", "MS PMincho", "ヒラギノ明朝 Pro W3", "Hiragino Mincho Pro", serif;
    line-height: 1.8em;
    margin-bottom: 10px;
  }
  .title a{
    border-left: #17f197 3px solid;
    font-size: 20px;
    color: #4c4c4c;
    padding-bottom: 3px;
    font-weight: 600;
    padding-left: 10px;
  }
</style>


// WEBPACK FOOTER //
// src/components/yinsi/index.vue